import { http } from '../utils/axios';
import { IUser } from '../interfaces/user.interface';
import {
  IAffiliate,
  IAffiliateSettingsUpdate
} from 'shared/interfaces/affiliate.interface';

class UserService {
  private static instance: UserService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }

    return UserService.instance;
  }

  getMe = async () => {
    const { data } = await http<IUser>({
      url: '/users/me',
      method: 'GET'
    });

    return data;
  };

  getAffiliate = async () => {
    const { data } = await http<IAffiliate>({
      url: '/affiliates/me',
      method: 'GET'
    });

    return data;
  };

  public updateAffiliate = async (payload: IAffiliateSettingsUpdate) => {
    const { data } = await http<IAffiliate>({
      url: '/affiliates/me',
      method: 'PUT',
      data: payload
    });

    return data;
  };

  public getAffiliateAdmins = async (payload: { status?: string }) => {
    const { data } = await http<IUser[]>({
      url: '/affiliates/admins',
      method: 'GET',
      params: { ...payload }
    });
    return data;
  };

  public createAffAdmin = async (payload: IUser) => {
    const { data } = await http<IUser>({
      url: '/users',
      method: 'POST',
      data: payload
    });

    return data;
  };
  public deleteAffAdmin = async (userId: string) => {
    await http({
      url: `/users/${userId}`,
      method: 'DELETE'
    });
  };
  public updateAffAdmin = async (payload: { id: string; data: IUser }) => {
    const { data } = await http<IUser>({
      url: `/users/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };
}

const instance = UserService.getInstance();

export default instance;
